import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { RoutePages } from 'src/app/enum/route-pages';
import { AuthService } from 'src/app/services/auth.service';
import { Role } from 'src/app/model/role';
import { AuthUtilService } from 'src/app/services/auth-util.service';
import { UserTypes } from 'src/app/enum/user-types';
import { ApiUrlUtil } from 'src/app/util/api-url-util';
import { map } from 'rxjs/operators';
import { RouteService } from 'src/app/services/route.service';

@Injectable()
export class ProfileValidateTeams implements CanActivate {

  constructor(
    private routeService: RouteService,
    private authUtilService: AuthUtilService,
    private authService: AuthService,
    private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {

    if (!this.authUtilService.getJwtToken()) {
      this.routeService.logout();
      return false;
    }

    return this.authService
      .getAuth()
      .pipe(
        map(e => {
          const roles = route.data['roles'] as Array<number>;
          return this.validadeRole(roles);
        })
      );
  }

  private validadeRole(roles: Array<number>): boolean {
    const userAuthProfile = this.authService.getProfile();
    if (!roles) return true;

    const canAcess = roles.includes(userAuthProfile);
    if (!canAcess) {
      this.router.navigateByUrl(RoutePages.SentEnvelope);
      return false;
    }

    return true;

  }
}
